import { PageSize } from '@/constant';
import {
	GetWorkerSalaryLisParams,
	IWorkerSalary,
	TPayloadUpdateSuccess,
} from '@/services';
import { mergeListItemUpdated } from '@/utils';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IPayloadDeleteWorkerSalaryRequest,
	IPayloadGetWorkerSalaryExcelListRequest,
	IPayloadGetWorkerSalaryListRequest,
	IPayloadGetWorkerSalaryListSuccess,
	IUpdateWorkerSalaryRequest,
	IWorkerSalaryDetailStore,
} from './worker-salary.type';
const InitParams: GetWorkerSalaryLisParams = {
	page: 1,
	pageSize: PageSize.S,
	searchTypes: [],
};
const initialState = {
	fetching: false,
	excelListFetching: false,
	workerSalaryList: [] as IWorkerSalaryDetailStore[],
	page: 1,
	total: 0,
	workerSalaryDetail: {} as IWorkerSalaryDetailStore,
	params: InitParams,
};

const workerSalarySlice = createSlice({
	initialState,
	name: 'workerSalary',
	reducers: {
		/**---- GET WORKER_SALARY LIST START ---- */
		getWorkerSalaryListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerSalaryListRequest>
		) => {
			state.fetching = true;
			state.params = action.payload;
		},
		getWorkerSalaryListSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkerSalaryListSuccess>
		) => {
			const { content, page, total } = action.payload;
			state.fetching = false;
			state.workerSalaryList = content;
			state.page = page;
			state.total = total;
		},
		getWorkerSalaryListFailure: (state) => {
			state.fetching = false;
			state.total = 0;
			state.workerSalaryList = [];
		},

		getWorkerSalaryExcelListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerSalaryExcelListRequest>
		) => {
			state.excelListFetching = true;
		},
		getWorkerSalaryExcelListSuccess: (state) => {
			state.excelListFetching = false;
		},
		getWorkerSalaryExcelListFailure: (state) => {
			state.excelListFetching = false;
		},
		/**---- GET WORKER_SALARY LIST END ---- */

		/**---- DELETE WORKER_SALARY START ---- */
		deleteWorkerSalaryRequest: (
			state,
			action: PayloadAction<IPayloadDeleteWorkerSalaryRequest>
		) => {
			state.fetching = true;
		},
		deleteWorkerSalarySuccess: (state) => {
			state.fetching = false;
		},
		deleteWorkerSalaryFailure: (state) => {
			state.fetching = false;
		},
		/**---- DELETE WORKER_SALARY END ---- */

		/**---- SAVE WORKER_SALARY START ---- */
		updateWorkerSalaryRequest: (
			state,
			action: PayloadAction<IUpdateWorkerSalaryRequest>
		) => {
			state.fetching = true;
		},
		updateWorkerSalarySuccess: (state) => {
			state.fetching = false;
		},
		updateWorkerSalaryFailure: (state) => {
			state.fetching = false;
		},
		/**---- SAVE WORKER_SALARY END ---- */

		/**---- UPDATE ROW WORKER_SALARY START ---- */
		updateRowWorkerSalarySuccess: (
			state,
			action: PayloadAction<TPayloadUpdateSuccess<IWorkerSalary>>
		) => {
			const { data } = action.payload;
			const content = [...state.workerSalaryList];
			state.workerSalaryList = mergeListItemUpdated(content, data);
		},
		/**---- UPDATE ROW WORKER_SALARY START ---- */
	},
});

export const WorkerSalarySelectors = {
	selectFetching: (state: RootState) => state.workerSalary.fetching,
	selectPage: (state: RootState) => state.workerSalary.page,
	selectTotal: (state: RootState) => state.workerSalary.total,
	selectWorkerSalaryList: (state: RootState) =>
		state.workerSalary.workerSalaryList,
	selectWorkerSalaryDetail: (state: RootState) =>
		state.workerSalary.workerSalaryDetail,
	selectParams: (state: RootState) => state.workerSalary.params,
};

export const WorkerSalaryActions = workerSalarySlice.actions;
export const WorkerSalaryReducer = workerSalarySlice.reducer;
